<template>
    <div>
        <div class="te-fat-section sm-b-s">{{ 'mead.additional_setup_required' | athT }}</div>
        <div clsss="validation-message">{{ uiValidationMessage }}</div>
    </div>
</template>
<script>
import { isNeObject } from '@aretheyhappy/utils';

export default {
    props: {
        /**
         * Validation result for the widget configuration, expected to expose an
         * errorMessages string describing what still needs to be set up.
         */
        validation: {type: Object, default: () => ({})}
    },
    computed: {
        uiValidationMessage: function () {
            return isNeObject(this.validation) ? this.validation.errorMessages : '';
        }
    }
}
</script>
<style lang="scss">
 .validation-message { white-space: pre-line; }
 </style>